import { defineComponent } from 'vue';
import Qrcode1 from '@/assets/image/home/qrcode1.jpg';
export default defineComponent({
  name: 'HomeAbout',
  setup: function () {
    return {
      Qrcode1: Qrcode1
    };
  }
});